const matchSelector = (state) => state.match.matchObj;
export default matchSelector;
